<template>
<div id="top-nav" class="fixed-top">
  <!-- <b-navbar type="light" :class="{'partition-nav': getClient.parent}"> -->
  <b-navbar type="light">
    <div class="nav-toggle"
         name="button"
         @click="updateNavClass"
         qid="side-nav-toggle"
    >
      <font-awesome-icon icon="bars" />
    </div>

    <!-- Clients dropdown -->
    <div v-if="!getClient.parent" class="client-picker-container color-blue client-picker" style="align-self: flex-start">
      <span class="small client-picker__label">
        {{ $t('administration.clients.label') }}
      </span>

      <multiselect
          class="client-picker__select"
          v-model="client"
          :options="clients"
          :multiple="false"
          :taggable="false"
          :allow-empty="false"
          required
          select-label=""
          selected-label=""
          deselect-label=""
          @input="updateClient(client)"
          @search-change="debounceClients"
          :internalSearch="false"
          track-by="slug"
          :placeholder="$t('administration.clients.title')"
          label="name"
          qid="search-c-input"
          :append-to-body="true"
          :close-on-select="true"
      >
        <!-- Selected (closed state) -->
        <template slot="singleLabel" slot-scope="props">
          <span class="client-picker__single">
            <Avatar :object="props.option" size="xs" class="client-picker__avatar" />
            <span class="client-picker__single-text">
              {{ props.option.name }}
            </span>
          </span>
        </template>

        <!-- Dropdown option row -->
        <template slot="option" slot-scope="props">
          <div class="client-picker__option">
            <Avatar
                :object="props.option"
                size="xs"
                class="client-picker__avatar client-picker__avatar--option"
                :class="{ 'client-picker__avatar--tall': props.option.cvr && props.option.reference_number }"
            />
            <div class="client-picker__option-body">
              <div class="client-picker__option-title">{{ props.option.name }}</div>

              <div class="client-picker__option-meta" v-if="props.option.cvr">
                CRN: {{ props.option.cvr }}
              </div>

              <div class="client-picker__option-meta" v-if="props.option.reference_number">
                REF: {{ props.option.reference_number }}
              </div>
            </div>
          </div>
          <b-dropdown-divider v-if="props.option !== partitions[partitions.length - 1]"/>
        </template>
      </multiselect>
    </div>


    <!-- Back to parent client -->
    <div v-if="getClient.parent"
         class="cursor-pointer client-picker-container color-blue client-picker"
         @click="updateClient(getClient.parent)"
    >
      <span class="small client-picker__label">
        {{ $t('administration.clients.label') }}
      </span>
      <div class="multiselect client-picker__select"
           style="padding: 6px 0">
        <span class=" mb-0 client-picker__single-text"
            :class="{'ml-3': getUser.clients && getUser.clients.length == 1}"
        >
          <font-awesome-icon
              icon="angle-left"
              class="left mr-1"
          />
          <Avatar :object="getClient.parent" size="xs"></Avatar>
          {{ getClient.parent.name }}
        </span>
      </div>
    </div>


    <!-- Partitions dropdown -->
    <div class="client-picker-container color-blue client-picker" :class="{'not-clickable': partitions && partitions.length < 1}" style="align-self: flex-start">
      <span class="small client-picker__label">
        {{ $t('administration.partitions.label') }}
      </span>
      <multiselect
          class="client-picker__select"
          v-model="partition"
          :options="partitions"
          :multiple="false"
          :taggable="false"
          @remove="updateClient(getClient.parent)"
          required
          select-label=""
          selected-label=""
          deselect-label=""
          @input="updateClient(partition)"
          @search-change="debouncePartitions"
          :internalSearch="false"
          track-by="slug"
          :placeholder="$t('administration.partitions.select')"
          label="name"
          qid="search-p-input"
          :append-to-body="true"
          :close-on-select="true"
      >
        <!-- Selected (closed state) -->
        <template slot="singleLabel" slot-scope="props">
          <span class="client-picker__single">
            <Avatar :object="props.option" size="xs" class="client-picker__avatar" />
            <span class="client-picker__single-text">
              {{ props.option.name }}
            </span>
          </span>
        </template>

        <!-- Dropdown option row -->
        <template slot="option" slot-scope="props">
          <div class="client-picker__option">
            <Avatar
                :object="props.option"
                size="xs"
                class="client-picker__avatar client-picker__avatar--option"
                :class="{ 'client-picker__avatar--tall': props.option.cvr && props.option.reference_number }"
            />
            <div class="client-picker__option-body">
              <div class="client-picker__option-title">{{ props.option.name }}</div>

              <div class="client-picker__option-meta" v-if="props.option.cvr">
                CRN: {{ props.option.cvr }}
              </div>

              <div class="client-picker__option-meta" v-if="props.option.reference_number">
                REF: {{ props.option.reference_number }}
              </div>
            </div>
          </div>
          <b-dropdown-divider v-if="props.option !== partitions[partitions.length - 1]"/>
        </template>
      </multiselect>
    </div>


    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto navbar-right hide-on-mobile">

      <router-link
          v-b-tooltip.hover
          :title="$t('maintenance.reports.title')"
          class="nav-link"
          :to="{name: 'maintenance.reports'}"
          qid="reports-link"
          v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        <font-awesome-icon icon="file-download" />
      </router-link>

      <router-link
          v-b-tooltip.hover
          :title="$t('maintenance.title')"
          class="nav-link"
          to="/maintenance"
          qid="navbar-maintenance-link"
          v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        <font-awesome-icon icon="cog" />
      </router-link>

      <Notifications></Notifications>

      <!-- Activity switch -->
      <a v-b-tooltip.hover
         :title="$t('top_nav.activity_log')"
         class="nav-link"
         qid="navbar-activity-link"
         @click="updateActivityClass"
      >
        <font-awesome-icon icon="wave-square" />
      </a>

      <!-- Language picker (compact nav item) -->
      <div class="nav-link nav-action nav-lang-picker cursor-pointer">
        <multiselect
            class="nav-lang-picker__select"
            v-model="selectedLang"
            :options="langOptions"
            :multiple="false"
            :taggable="false"
            :allow-empty="false"
            :searchable="false"
            track-by="value"
            label="title"
            select-label=""
            selected-label=""
            deselect-label=""
            qid="navbar-language-select"
            @input="selectLanguage"
        >
          <template slot="singleLabel" slot-scope="props">
      <span class="nav-pill nav-pill--lang" aria-label="Language">
        <img
            class="nav-lang-picker__flag"
            :src="getFlagSrc(props.option.value)"
            alt=""
        >
        <font-awesome-icon icon="angle-down" class="nav-pill__chevron" />
      </span>
          </template>

          <template slot="option" slot-scope="props">
            <div class="client-picker__option">
              <img
                  class="nav-lang-picker__flag nav-lang-picker__flag--option"
                  :src="getFlagSrc(props.option.value)"
                  alt=""
              >
              <div class="client-picker__option-body">
                <div class="client-picker__option-title">
                  {{ props.option.title }}
                </div>
              </div>
            </div>
          </template>
        </multiselect>
      </div>

      <!-- User dropdown (UPDATED button layout) -->
      <b-nav-item-dropdown
          right
          extra-gle-classes="no-dropdown-caret"
          qid="navbar-user-dropdown"
          class="user-dropdown user-dropdown--pill"
      >
        <template slot="button-content" qid="user-dropdown">
          <span class="nav-pill nav-pill--user" aria-label="User menu">
            <img
                :src="getProfileAvatar()"
                class="rounded-circle nav-pill__avatar"
                width="30"
                height="30"
                qid="profile-photo"
                alt=""
            >
            <font-awesome-icon icon="angle-down" class="nav-pill__chevron" />
          </span>
        </template>

        <!-- My profile -->
        <router-link
            :to="{ name: 'profile', params: { slug: getUser.slug }}"
            qid="user-dropdown-profile-link"
            class="dropdown-item dropdown-item--link user-menu__item"
        >
          <div class="client-picker__option user-menu__row">
            <img
                :src="getProfileAvatar()"
                class="rounded-circle client-picker__avatar user-menu__avatar"
                alt=""
            >
            <div class="client-picker__option-body">
              <div class="client-picker__option-title">
                {{ $t('top_nav.user_dropdown.my_profile') }}
              </div>
              <div class="client-picker__option-meta">
                {{ getUser.name }}
              </div>
            </div>
          </div>
        </router-link>

        <b-dropdown-divider v-if="checkAdmin(permissions.MAINTENANCE_VIEW)"></b-dropdown-divider>

        <!-- Client / partition profile -->
        <router-link
            :to="{ name: 'clientProfile', params: { slug: getClient.slug }}"
            qid="user-dropdown-clientprofile-link"
            v-if="isGranted(permissions.MAINTENANCE_VIEW)"
            class="dropdown-item dropdown-item--link user-menu__item"
        >
          <div class="client-picker__option user-menu__row">
            <Avatar
                :object="getClient"
                size="xs"
                class="client-picker__avatar user-menu__client-avatar"
            />
            <div class="client-picker__option-body">
              <div class="client-picker__option-title">
                <span v-if="getClient.parent">{{ $t('top_nav.user_dropdown.partition_profile') }}</span>
                <span v-else>{{ $t('top_nav.user_dropdown.client_profile') }}</span>
              </div>
              <div class="client-picker__option-meta">
                {{ getClient.name }}
              </div>
            </div>
          </div>
        </router-link>

        <b-dropdown-divider v-if="checkAdmin(permissions.ROLE_SUPER_ADMIN)"></b-dropdown-divider>

        <!-- Administration -->
        <router-link
            to="/administration"
            qid="user-dropdown-administration-link"
            v-if="checkAdmin(permissions.ROLE_SUPER_ADMIN)"
            class="dropdown-item dropdown-item--link user-menu__item"
        >
          <div class="client-picker__option user-menu__row">
            <span class="user-menu__icon">
              <font-awesome-icon icon="cog" />
            </span>
            <div class="client-picker__option-body">
              <div class="client-picker__option-title">
                {{ $t('top_nav.user_dropdown.administration') }}
              </div>
            </div>
          </div>
        </router-link>

        <b-dropdown-divider></b-dropdown-divider>

        <!-- Logout -->
        <b-dropdown-item
            @click="logout"
            qid="user-dropdown-logout"
            class="dropdown-item dropdown-item--link user-menu__item"
        >
          <div class="client-picker__option user-menu__row">
            <span class="user-menu__icon">
              <font-awesome-icon icon="sign-out-alt" />
            </span>
            <div class="client-picker__option-body">
              <div class="client-picker__option-title">
                {{ $t('top_nav.user_dropdown.logout') }}
              </div>
            </div>
          </div>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>

  <div class="trial-badge" v-if="getClient.subscription_status == 'trial'">
    <router-link :to="{ name: 'clientProfile', params: { slug: getClient.slug }, query: { tabindex: 1 }}">
      {{ $t('profile.client.billing.trial_label') }}
      {{ $t('profile.client.billing.expires_in') }}
      {{ getDifference(getClient.trial_ends_at) + 1 }}
      {{ $t('system.days') }}
    </router-link>
  </div>
  <div class="trial-expired-badge" v-if="getClient.subscription_status == 'trial_expired'">
    <router-link :to="{ name: 'clientProfile', params: { slug: getClient.slug }, query: { tabindex: 1 }}">
      {{ $t('profile.client.billing.trial_expired_label') }}
    </router-link>
  </div>

</div>
</template>

<script>
import piincHttp from '../util/configureAxios.js'
import permissionMap from '../util/ACL/permissionMap.js'
import {config} from '@/config.js'
import permissionCheck from "../util/ACL/permissionCheck";
import Avatar from '@/components/Avatar.vue';
import Notifications from '@/components/notification/Notifications.vue';

export default {
  name: 'TopNavigation',
  data: function() {
    return {
      user: this.$store.state.user,
      reloadActivity: false,
      client: "",
      partition: "",
      partitions: [],
      clients: [],
      selectedLang: [],
      langOptions: [
        {value: 'en', title: 'English'},
        {value: 'da', title: 'Dansk'},
        {value: 'fr', title: 'French'},
        {value: 'de', title: 'German'}
      ],
      showLanguageOptions: false,
    }
  },
  computed: {
    getUser() {
      return this.$store.state.user
    },
    getClients() {
      let clients = [];
      if (this.$store.state.user.clients) {
        for (var i = 0; i < this.$store.state.user.clients.length; i++) {
          if (!this.$store.state.user.clients[i].parent){
            clients.push(this.$store.state.user.clients[i]);
          }
        }
        if (clients && clients.length) {
          clients.sort(function(a, b) {
            var nameA = a.name.toUpperCase(); // ignore upper and lowercase
            var nameB = b.name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            // names must be equal
            return 0;
          });
        }
      }
      return clients
    },
    getClient() {
      return this.$store.state.client
    }
  },
  components:{
    Notifications,
    Avatar
  },
  watch: {
    getClient: function (value) {
      if (value && value.slug) {
        this.loadPartitions();
      }
    },
    getUser: function (value) {
      if (value) {
        if (this.getClient && this.getClient.slug) {
          this.loadPartitions();
        }
      }
    }
  },
  methods: {
    debounceClients: _.debounce(function(keyword) {
      this.loadClients(keyword)
    }, 500),
    debouncePartitions: _.debounce(function(keyword) {
      this.loadPartitionsSearch(keyword)
    }, 500),
    updateNavClass() {
      // Update top level class to collapsed
      let topElement = document.getElementById("app");
      topElement.classList.toggle("sidebar-collapsed");
    },
    getDifference(endDate) {
      var moment = require('moment');
      let currentDate = moment()
      endDate = moment(endDate);
      let difference = endDate.diff(currentDate, 'days');
      return difference;
    },
    isMemberOfClient(client) {
      let isMember = false;
      if (this.$store.state.user.clients) {
        for (var i = 0; i < this.$store.state.user.clients.length; i++) {
          if (this.$store.state.user.clients[i].slug == client.slug){
            isMember = true;
          }
        }
      }
      return isMember;
    },
    handleLanguageOptions(evt) {
      evt.stopPropagation()
      this.showLanguageOptions = !this.showLanguageOptions
    },
    selectLanguage(item) {
      localStorage.setItem('lang', item.value)
      window.location.reload()
    },
    loadPartitions(query) {
      let self = this;
      piincHttp.get('partitions', { params: {
        client: self.getClient.parent ? self.getClient.parent.slug : self.getClient.slug,
        per_page: 0,
        sort: 'name',
        order: 'asc',
        mine: !this.getUser.isAdmin ? 1 : undefined
      }}).then(function(response) {
        self.partitions = response.data.items;

        if (self.getClient.parent) {
          self.client = self.getClient.parent;
          self.partition = self.getClient;
        } else {
          self.client = self.getClient;
          self.partition = [];
        }
      }, function() {});
    },
    loadPartitionsSearch(query) {
      let self = this;
      piincHttp.get('partitions', { params: {
        client: self.getClient.parent ? self.getClient.parent.slug : self.getClient.slug,
        per_page: 0,
        sort: 'name',
        order: 'asc',
        keyword: query ? query : undefined,
        mine: !this.getUser.isAdmin ? 1 : undefined
      }}).then(function(response) {
        self.partitions = response.data.items;
      }, function() {});
    },
    loadClients(query) {
      let self = this;
      piincHttp.get('clients', { params: {
        per_page: 100,
        without_partition: 1,
        member: !this.getUser.isAdmin ? this.getUser.id : undefined,
        keyword: query ? query : undefined
      }}).then(function(response) {
        self.clients = response.data.items;
      }, function() {});
    },
    updateActivityClass() {
      this.reloadActivity = !this.reloadActivity;
      // Update top level class to collapsed only if main navigation
      let topElement = document.getElementById("app");
      topElement.classList.toggle("activity-collapsed");
      if (!topElement.classList.contains("guide-collapsed")) {
        topElement.classList.toggle("guide-collapsed");
        this.$store.commit('storeHelpCenterState', false);
      }
      this.$emit('reloadActivity', this.reloadActivity);
    },
    updateClient(client) {
      let self = this;
      let selectedClient = client;
      piincHttp.get('users/me/permissions/' + selectedClient.slug).then(function(response) {
        selectedClient.user_permissions = response.data.user_permissions
        selectedClient.user_roles = response.data.user_roles
        localStorage.setItem('clientObject', JSON.stringify(selectedClient));
        localStorage.setItem('client', selectedClient.slug);
        self.$store.commit('storeClient', selectedClient);
      }, function() {});
    },
    logout() {
      let self = this;
      piincHttp.post('logout').then(function() {
        localStorage.removeItem('token')
        localStorage.removeItem('client')
        localStorage.removeItem('clientObject')
        self.$store.commit('storeHistoryPage', '');
        setTimeout( function () {
          window.location.href = '/login'
        }, 500);
      }, function(error) {
        alert(error)
      })
    },
    getProfileAvatar(){
      let user = this.$store.state.user;
      let link = ''
      if (user.avatar) {
        return user.avatar;
      } else {
        return require('@/assets/avatar.png');
      }
    },
    checkAdmin(role) {
      let hasRole = false;
      let user = this.$store.state.user;
      if (user.isAdmin) {
        hasRole = true;
      }
      // Return Boolean if user has given role
      return hasRole;
    },
    getFlagSrc(langValue) {
      switch (langValue) {
        case 'en': return require('@/assets/en.png');
        case 'da': return require('@/assets/da.png');
        case 'fr': return require('@/assets/fr.png');
        case 'de': return require('@/assets/de.png');
        default: return require('@/assets/en.png');
      }
    },
  },
  created() {
    let self = this;

    this.loadClients();

    if (this.getClient && this.getClient.slug) {
      this.loadPartitions();
    }

    if (localStorage.getItem('lang')) {
      _.find(self.langOptions, function(item) {
        if (item.value === localStorage.getItem('lang')) {
          self.selectedLang = item;
        }
      });
    } else {
      this.selectedLang = this.langOptions[0]
    }
  }
}
</script>
